import { render, staticRenderFns } from "./DepreciationList.vue?vue&type=template&id=56e7d381&scoped=true"
import script from "./DepreciationList.vue?vue&type=script&lang=js"
export * from "./DepreciationList.vue?vue&type=script&lang=js"
import style0 from "./DepreciationList.vue?vue&type=style&index=0&id=56e7d381&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7d381",
  null
  
)

export default component.exports